import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  automaticSchedules: [],
  cellSize: null,
  chlorinatorMeasure: 0,
  currentSchedule: { title: '', startTemp: 0, endTemp: 0, time: 0, schedules: [] },
  currentStep: 0,
  disabledSensorsStep: false,
  disableMessage: '',
  firstSetup: true,
  inhibitSensor: false,
  inputError: false,
  isLoading: false,
  modalOpen: false,
  modalTitle: '',
  operatingMode: 0,
  poolSize: 0,
  salinity: 4,
};

const chlorinatorSlice = createSlice({
  name: 'chlorinator',
  initialState,
  reducers: {
    decreaseStep(state) {
      state.currentStep--;
    },
    increaseStep(state) {
      state.currentStep++;
    },
    resetState() {
      return { ...initialState };
    },
    resetStepState() {
      return { currentStep: 0 };
    },
    setCellSize(state, action) {
      state.cellSize = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setOperatingMode(state, action) {
      state.operatingMode = action.payload;
    },
    setPoolSize(state, action) {
      state.poolSize = action.payload;
    },
    setSalinity(state, action) {
      state.salinity = action.payload;
    },
    setDisabledSensorsStep(state, action) {
      state.disabledSensorsStep = action.payload;
    },
    setDisableMessage(state, action) {
      state.disableMessage = action.payload;
    },
    setInputError(state, action) {
      state.inputError = action.payload;
    },
    setChlorinatorMeasure(state) {
      state.chlorinatorMeasure = state.chlorinatorMeasure == 0 ? 1 : 0;
    },
    setInhibitSensor(state, action) {
      state.inhibitSensor = action.payload;
    },
    setFistSetup(state, action) {
      state.isFirstSetup = action.payload;
    },
    setModalTitle(state, action) {
      state.modalTitle = action.payload;
    },
    setModalOpen(state) {
      state.modalOpen = !state.modalOpen;
    },
    setAutomaticSchedules(state, action) {
      state.automaticSchedules = action.payload;
    },
    updateScheduleAtIndex(state, action) {
      const { index, schedule } = action.payload;
      if (index >= 0 && index < state.automaticSchedules.length) {
        state.automaticSchedules[index] = schedule;
      }
    },
    setCurrentSchedule(state, action) {
      state.currentSchedule = action.payload;
    },
    changeCurrentSchedule(state, action) {
      if (state.currentSchedule) {
        state.currentSchedule[action.payload.key] = action.payload.value;
      }
    },
    changeCurrentScheduleElement(state, action) {
      if (
        state.currentSchedule &&
        action.payload.index >= 0 &&
        action.payload.index < state.currentSchedule.schedules.length
      ) {
        state.currentSchedule.schedules[action.payload.index][action.payload.key] =
          action.payload.value;
      }
    },
  },
});

export const chlorinatorActions = chlorinatorSlice.actions;

export default chlorinatorSlice;
